import { useCallback, useEffect, useState } from 'react'
import { getSelection } from '../../services/selections'
import { logger } from '../../utils/logger'

export interface SelectionFetchState {
  selectedIds: Set<string>
  setSelectedIds: React.Dispatch<React.SetStateAction<Set<string>>>
  loading: boolean
  error: string | null
  setError: React.Dispatch<React.SetStateAction<string | null>>
  refetch: () => Promise<void>
}

export function useSelectionFetch(caseId: string | null): SelectionFetchState {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set())
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async () => {
    if (!caseId) {
      setSelectedIds(new Set())
      setError(null)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const data = await getSelection(caseId)
      setSelectedIds(new Set(data.selectedEndpointIds))
    } catch (err) {
      logger.warn('useSelection', 'Failed to fetch selection from backend', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch selection')
    } finally {
      setLoading(false)
    }
  }, [caseId])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { selectedIds, setSelectedIds, loading, error, setError, refetch }
}
